import React from "react";
import { FaUser, FaSignOutAlt } from "react-icons/fa";

const Menu = ({ onPersonalInfoClick, onLogoutClick }) => {
  return (
    <div className="bg-white shadow-md rounded-md p-4">
      {/* Personal Info Button */}
      <a
        href="/personal-info"
        className="flex items-center w-full text-left space-x-3 p-2 rounded-md hover:bg-gray-100 z-[99]"
      >
        <FaUser className="text-gray-600" />
        <span className="text-gray-800 font-medium">Personal Info</span>
      </a>

      {/* Logout Button */}
      <button
        onClick={onLogoutClick}
        className="flex items-center w-full text-left space-x-3 p-2 rounded-md hover:bg-gray-100 mt-2"
      >
        <FaSignOutAlt className="text-gray-600" />
        <span className="text-gray-800 font-medium">Logout</span>
      </button>
    </div>
  );
};

export default Menu;
